import { lazy } from "react";

const Home = lazy(() => import("../_pages/Home"));
const TrainModule = lazy(() => import("../_pages/TrainModule"));
const SessionCategoryManagement = lazy(() =>
  import("../_pages/SessionCategoryManagement")
);
const ReviewManagement = lazy(() => import("../_pages/ReviewManagement"));
const UserManagement = lazy(() => import("../_pages/UserManagement"));

const ProtectedRotues = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/train-module",
    element: <TrainModule />,
  },
  {
    path: "/session-category-management",
    element: <SessionCategoryManagement />,
  },
  {
    path: "/review-management",
    element: <ReviewManagement />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
];

export default ProtectedRotues;
